import {
  put, call, select, all,
} from 'redux-saga/effects'

import { FEED_PAGE_SIZE } from '../../../../../helpers/const'
import { fetchFlyerGibsPage } from '../../../../../api/products/fetchFlyerGibsPage'
import { fetchFlyerGibsCount } from '../../../../../api/products/fetchFlyerGibsCount'
import manipulateProducts from '../../../../manipulators/2.0/products'
import { appendProducts } from '../../../../actions/products'
import { setFeedLoading, setFeedPage } from '../../../../actions/feed'
import { selectFeedQuery } from '../../../../selectors/feed'
import getManipulationContext from './getManipulationContext'

/*
  Fetches one page of the feed and REPLACES the visible list (classic
  pagination, one page at a time -> the DOM stays small). The products map
  keeps every gib ever fetched as a cache. Serves both page navigation and
  server-side search: the active query is read from the store.

  The filtered total drives pagination, so it is read from the dedicated
  /count endpoint with the same query (the list endpoint does not return a
  reliable total). Fetched alongside the page so totalPages tracks the query.
*/
function* getFlyerGibsPage(action) {
  const { flyerId, page, country } = action.payload

  const query = yield select(selectFeedQuery)

  yield put(setFeedLoading(true))
  try {
    const [pageResponse, countResponse] = yield all([
      call(fetchFlyerGibsPage, {
        country, flyerId, page, limit: FEED_PAGE_SIZE, q: query || undefined,
      }),
      call(fetchFlyerGibsCount, { country, flyerId, q: query || undefined }),
    ])
    const { data } = pageResponse || {}

    // drop stale responses: a newer search/page request superseded this one
    const currentQuery = yield select(selectFeedQuery)
    if (query !== currentQuery) return

    const { currentDate, isPreview, favouriteProductIds } = getManipulationContext()
    const { products } = manipulateProducts(
      data || [],
      currentDate,
      isPreview,
      favouriteProductIds,
      (page - 1) * FEED_PAGE_SIZE,
    )

    /**
     * If, for some reason, the count does not return a valid number, we are using
     * the first page results length to establish the totalCount and, consequently,
     * if paginationis needed or not
     */
    const feedCount = Number(countResponse?.metadata?.count)
    const firstPageResultsCount = Object.keys(products)?.length || 0

    const totalCount = (
      !Number.isNaN(feedCount) ? feedCount : firstPageResultsCount
    )

    yield put(appendProducts(products))
    yield put(setFeedPage({ items: Object.keys(products), page, totalCount }))
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error)
  } finally {
    // only the request matching the current query may clear the loading flag
    const currentQuery = yield select(selectFeedQuery)
    if (query === currentQuery) yield put(setFeedLoading(false))
  }
}

export default getFlyerGibsPage
